module.exports = __webpack_public_path__ + "img/ring_gift.a36020cf.svg";